import { render, staticRenderFns } from "./wasteReportUpload.vue?vue&type=template&id=36eadee4"
import script from "./wasteReportUpload.vue?vue&type=script&lang=js"
export * from "./wasteReportUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36eadee4')) {
      api.createRecord('36eadee4', component.options)
    } else {
      api.reload('36eadee4', component.options)
    }
    module.hot.accept("./wasteReportUpload.vue?vue&type=template&id=36eadee4", function () {
      api.rerender('36eadee4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/waste/wasteReportUpload.vue"
export default component.exports